import gql from 'graphql-tag';

export const GET_SERVICES = gql`
  query Services($name: String) {
    services(name: $name) {
      id
      name
    }
  }
`;
